/**
 * Attempts to access window.localStorage, and retrieve item with provided name.
 * @param {String} name - Name of the item requested.
 */
export function getFromLocalStorage(name) {
  if (isLocalStorageAvailable()) {
    return localStorage.getItem(name)
  }
  return false
}

/**
 * Attempts to access window.localStorage, and store an item into it.
 * @param {String} name - Name of the item to be stored.
 * @param {String} val - Value of the item to be stored.
 */
export function setToLocalStorage(name, val) {
  if (isLocalStorageAvailable()) {
    localStorage.setItem(name, val)
  }
}

/**
 * Check availability of window.localStorage.
 */
export function isLocalStorageAvailable() {
  try {
    localStorage.setItem('availabilityTest', 'success')
    localStorage.removeItem('availabilityTest')
    return true
  } catch (e) {
    return false
  }
}
